    let url_p = "/cart"
if (window.location.href.indexOf("/en") > -1) {
   url_p = "/en/cart"
}else if(window.location.href.indexOf("/es") > -1){
   url_p = "/es/cart"
}else if(window.location.href.indexOf("/it") > -1){
   url_p = "/it/cart"
}else if(window.location.href.indexOf("/de") > -1){
   url_p = "/de/cart"
}
     function addFreeProductsToCart() {
        // Check if we should add free products
        if ($(".free_products_form form:first-child").length === 0 || 
            $(".line-item[data_free]").length > 0) {
          return Promise.resolve(); // No free products to add or already added
        }
      
        const $freeForms = $(".free_products_form form");
        let promiseChain = Promise.resolve();
      
        // Process each form sequentially
        $freeForms.each(function(index) {
          promiseChain = promiseChain.then(() => {
            return $.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: $(this).serialize(),
              dataType: 'json'
            });
          });
        });
      
        return promiseChain;
      }
 function cart_get_data(url_p){
            $.ajax({
          type: 'GET',
          url: '/cart.js',
          dataType: 'json',
          success: function(cartdata){
            $('#cart-count').html(cartdata.item_count);
            $('.cart-count-bubble span').html(cartdata.item_count);
            if(cartdata.item_count > 0){
              if($(".cart-count-bubble").length > 0){
              }else{
                $(".header__icon--cart").append("<div class='cart-count-bubble'><span aria-hidden='true'>"+ cartdata.item_count +"</span></div>")
              }
              $('.cart-count-bubble').removeClass('visually-hidden');
            }
            if(cartdata.item_count == 0){
              $('.cart-count-bubble').addClass('visually-hidden');
            }
            $.ajax({
              type: "GET",
              url: url_p,
              dataType: 'html',
              success: function(data){
               var minicartdata = $(data).filter('#slidingcartmain').html();
                  var progree_msg = $(data).find(".cust-shptxt").html();
                var progree_width = $(data).find(".cust-prg b").attr("style");
                $(".inline-cart").removeClass("cart_empty");
                addRemoveProgress_s(progree_msg,progree_width);
                setTimeout(function(){
                   upsells_slick();
                },200)
                if (window.location.href.indexOf("/cart") > -1) {
                    var cartdata = $(data).find('.c_cart_items').html();
                    $('.c_cart_items').html(cartdata);
                    var carttotals = $(data).find('.price-subtotals').html();       
                    $('.price-subtotals').html(carttotals);
                     $(".c_cart_container .empty_cart").css("display","none");
                      $(".c_cart_container .cart_subtotal_mobile").removeClass("hidden");
                      $(".c_cart_container .reserved_text").css("display","flex");
                      $(".c_cart_container .c_cart_items").css("display","block");
                      $(".c_cart_container .c_cart_checkout").css("display","block");
                  }
                   if($(".custom_upsells").length){
                $(".custom_upsells").removeClass("active");
                 $(".upps_atc").removeClass("loading")
            }
                  $('#slidingcartmain').html(minicartdata);
                $("#overlay").addClass("is-active");
                $("#slidingcartmain").removeClass("slide_empty");
                $(".alm-cart-empty").remove();
                $(".inline-cart").addClass("is-active");
                $('body').addClass('cstm_toggle_cls');
                $('body').addClass('slidecart-is-open');
                $('html').addClass('slidecart-is-open');
                $(".product-form__submit").removeClass("active");
              }
            });

          }

        });
  }
function check_promo(){
  
  $.ajax({
          type: 'GET',
          url: url_p,
          dataType: 'json',
          success: function(cartdata){
                console.log(cartdata.cart_level_discount_applications[0].title);
                if(cartdata.cart_level_discount_applications[0].title != null){
                  $("#discount-code-input").val(cartdata.cart_level_discount_applications[0].title);
                  $(".promo_added").css("display","flex");
                  $(".promo_remove").css("display","flex");
                   $("#discount-code-input").attr("disabled","disabled");
                  setTimeout(function(){             
                     let priceElement = document.querySelector("#cart_original_price span");
                      let originalText = priceElement.innerHTML;

                      // Extract the currency symbol (everything that's NOT a digit, comma, or dot)
                      let currencyMatch = originalText.match(/[^\d,\.]+$/); // Matches non-digit characters at the end
                      let currency_no_price = currencyMatch ? currencyMatch[0] : '';

                      // Extract price number (all digits and comma/decimal point)
                      let priceMatch = originalText.match(/[\d,\.]+/);
                      let price_no_currency_or = priceMatch ? priceMatch[0] : '';
                      $(".promo_price").html((cartdata.total_price/100).toFixed(2) + currency_no_price);
                       $("#cart_original_price span").addClass("strikeprice");
                  },500)
                  
                }

          }
 })
}
check_promo();

function addRemoveProgress_s(s,w){     
           /*       $(".cust-shptxt").html(s);
                   if(w != undefined){
                   $(".cust-prg b").attr("style",w);
                     console.log(w);
                       let prog_f = w.replace('width:','').replace("%","").replace(";","");
                      $(".custom_progress_icon").each(function( index ) {
                        let prog_x = $(this).attr("style").replace('left:','').replace('%','').replace(";","");
                          if(parseInt(prog_x) <= parseInt(prog_f) ){
                            $(this).addClass("active")
                          }else{
                             $(this).removeClass("active")
                          }
                              });
                   }*/
                    
  }
  function addRemoveProgress(s,w){          
          /*        $(".cust-shptxt").html(s);
                   $(".cust-prg b").attr("style",w);*/
  }
function coupon_add(){
        var promoCode = $("#discount-code-input").val();
        console.log(promoCode)
          $(".discount-code__submit svg").css("display","flex");
           $.ajax({
            url: '/discount/' + promoCode, // Shopify endpoint for discount codes
            type: 'GET',
            success: function(response) {
              $.ajax({
          type: 'GET',
          url: url_p,
          dataType: 'json',
          success: function(cartdata){
                console.log(cartdata);
                $(".discount-code__submit svg").css("display","none");
             //   $("#discount-code-input").val(cartdata)
             if(cartdata.cart_level_discount_applications[0].title != null){
                  $("#discount-code-input").val(cartdata.cart_level_discount_applications[0].title);
               $("#discount-code-input").attr("disabled","disabled");
               $(".promo_remove").css("display","flex");
               $(".promo_added").css("display","flex");
                }
                      let priceElement = document.querySelector("#cart_original_price span");
                      let originalText = priceElement.innerHTML;

                      // Extract the currency symbol (everything that's NOT a digit, comma, or dot)
                      let currencyMatch = originalText.match(/[^\d,\.]+$/); // Matches non-digit characters at the end
                      let currency_no_price = currencyMatch ? currencyMatch[0] : '';

                      // Extract price number (all digits and comma/decimal point)
                      let priceMatch = originalText.match(/[\d,\.]+/);
                      let price_no_currency_or = priceMatch ? priceMatch[0] : '';
                      $(".promo_price").html((cartdata.total_price/100).toFixed(2) + currency_no_price);
            $("#cart_original_price span").addClass("strikeprice");
                }
              })
            },
            error: function(xhr, status, error) {
                alert("An error occurred: " + xhr.responseText);
            }
        });
}
function promo_remove() {
    $(".discount-code__submit svg").css("display", "flex");

    // 1. We use the /cart/update.js API to explicitly set the discount to an empty string.
    // This is the most modern way to communicate with the cart session.
    fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
            attributes: { 'discount': '' }, // Clear any custom attributes
            discount: '' // The magic line
        })
    })
    .then(response => {
        // 2. Now we call the clear endpoint just to be 100% sure the session cookie is killed
        return fetch('/discount/clear');
    })
    .then(() => {
        // 3. Get the fresh cart
        return fetch(window.Shopify.routes.root + 'cart.js');
    })
    .then(response => response.json())
    .then(cart => {
        console.log("Final Check - Total Discount:", cart.total_discount);

        if (cart.total_discount === 0) {
            // UI Updates
            $("#discount-code-input").val("").removeAttr("disabled");
            $(".promo_remove, .promo_added").hide();
            $(".promo_price").html("");
            $("#cart_original_price span").removeClass("strikeprice");
            $(".discount-code__submit svg").hide();
            
            // If it's a drawer cart, you MUST re-render it here
            // Example: if (typeof refreshCartDrawer === 'function') refreshCartDrawer();
        } else {
            // If it STILL isn't 0, the only way is a hard refresh
            console.log("Session stubborn - performing hard refresh...");
            window.location.reload();
        }
    })
    .catch(error => {
        console.error("Error:", error);
        $(".discount-code__submit svg").hide();
    });
}
function upsells_slick(){
  check_promo();
if(document.querySelector(".upsells_container") != null){
if(document.querySelector(".upsells_container").classList.contains("slick-slider")){
 $('.upsells_container').slick('unslick');
}

  $('.upsells_container').slick({
   dots: false, 
   arrows: true,
    infinite: true,
    autoplay:false,
    slidesToShow:1,slidesToScroll:1,
        draggable: true,
       swipe:true,
        prevArrow:$(".splide__arrow--prev"),
        nextArrow:$(".splide__arrow--next"),
    
  });
}

$(".card__size-value button").click(function(e){
    e.preventDefault();
    let elements = $(this);
    let selectedVariantId = $(this).attr("id");
    
    // Find the corresponding variant in pro_vars and update the free product form
    let freeProductForm = elements.closest(".card-grid-centered").find(".c_free_products_form");
    let proVarsOptions = freeProductForm.find(".pro_vars div");
    
    // Get the button text and normalize it (trim and remove extra spaces)
    let selectedButtonText = $(this).text().trim().replace(/\s+/g, ' ');
    
    // Find the matching variant in pro_vars based on the selected variant title
    let matchingProVar = proVarsOptions.filter(function() {
        // Normalize the text for comparison
        return $(this).text().trim().replace(/\s+/g, ' ') === selectedButtonText;
    });

    if (matchingProVar.length) {
        // If found matching variant in pro_vars, use its data-id
        freeProductForm.find("[name='id']").val(matchingProVar.attr("data-id"));
    } else {
        // Otherwise fall back to first variant (original behavior)
        freeProductForm.find("[name='id']").val(proVarsOptions.first().attr("data-id"));
    }
    
    // Rest of your AJAX code remains the same
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: $(this).closest(".card__size-value").find("input,select,textarea").serialize(),
        dataType: 'json',
        success: function(response){
            console.log(elements.closest(".card-grid-centered").find("input,select,textarea").serialize())
            if(elements.closest(".card-grid-centered").find(".c_free_products_form").find("input,select,textarea").length){
                $.ajax({
                    type: 'POST',
                    url: '/cart/add.js',
                    data: elements.closest(".card-grid-centered").find(".c_free_products_form").find("input,select,textarea").serialize(),
                    dataType: 'json',
                    success: function(response){
                        addFreeProductsToCart()
                        .finally(() => {
                            cart_get_data(url_p); // Always refresh cart data
                        });
                    } 
                })
            } else {
                addFreeProductsToCart()
                .finally(() => {
                    cart_get_data(url_p); // Always refresh cart data
                });
            }
        },
        error: function(resp) {
            var getres = JSON.stringify(resp);
            alert(resp.responseJSON.description);
        }
    });
});

  
}
upsells_slick()




$(document).ready(function(){
 
  $(".header__icon--cart").click(function(e){
    e.preventDefault();

    /*BS team: added this code becuase mini-cart should not open cart page */
    if ($(location).attr("href").includes('/cart'))
      return;
    /***********/

    $("#overlay").addClass("is-active");
    $(".inline-cart").addClass("is-active");
    $('body').addClass('slidecart-is-open');
    $('html').addClass('slidecart-is-open');
  });
  
  $(document).on('click','.clscrt',function(){
    $("#overlay").removeClass("is-active");
    $(".inline-cart").removeClass("is-active");
    $('body').removeClass('slidecart-is-open');
    $('html').removeClass('slidecart-is-open');
  });

  $('.top_header_new_cart').click(function(){
    $('body').addClass('cstm_toggle_cls');   
  });

  $("#overlay").click(function(){
    $('body').removeClass('cstm_toggle_cls');  
  });

  $(".cart-header, .cust-fre-shp, .slidecartitmmain").click(function(){
  /*  $('body').removeClass('slidecart-is-open');
    $('html').removeClass('slidecart-is-open');
    $('body').removeClass('cstm_toggle_cls');  */
  });

 /* $('.cart-header, .cust-fre-shp, .slidecartitmmain').click( function(e){
    e.preventDefault();
  });*/

  $('body').on('click', '.continueshopping', function(e){
    e.preventDefault();
    $("#overlay").removeClass("is-active");
    $(".inline-cart").removeClass("is-active");
    $('body').removeClass('slidecart-is-open');
    $('html').removeClass('slidecart-is-open');
  });

  $('body').on('click', '#overlay', function(){
    $("#overlay").removeClass("is-active");
    $(".inline-cart").removeClass("is-active");
    $('body').removeClass('slidecart-is-open');
    $('html').removeClass('slidecart-is-open');
  });

  $("body").on("click", ".qtyplus", function () {
    var t = +$(this).siblings(".changequantity").val() + 1;
    $(this).siblings(".changequantity").val(t);
  });

  $("body").on("click", ".qtyminus", function () {
    var t = +$(this).siblings(".changequantity").val() - 1;
    t < 1 && (t = 1), $(this).siblings(".changequantity").val(t);
  });


  
  $("body").on("click", ".qtyplus, .qtyminus", function () {
    var a = $(this).siblings(".changequantity").val();
      var t =$(this).siblings(".changequantity").attr("data-line-item-index");
    $.ajax({
      type: "POST",
      url: "/cart/change.js",
      data: "quantity=" + a + "&line=" + t,
      dataType: "json",
      success: function (t) {     
        console.log(t.item_count);
          $(".cart-count-bubble span").html(t.item_count),
          $.ajax({
          type: "GET",
          url: url_p,
          dataType: "html",
          success: function (t) {   
            $('.cart-count-bubble').removeClass('visually-hidden');
                var minicartdata = $(t).filter('#slidingcartmain').html();
                var progree_msg = $(t).find(".cust-shptxt").html();
                var progree_width = $(t).find(".cust-prg b").attr("style");
               var maincart = $(minicartdata).find('.slidecartitmmain').html();
                var maincartprice = $(minicartdata).find('.slidecart_form').html();
            addRemoveProgress_s(progree_msg,progree_width);
           setTimeout(function(){
                   upsells_slick();
                },200)
                 if (window.location.href.indexOf("/cart") > -1) {
                    var cartdata = $(t).find('.c_cart_items').html();
                    $('.c_cart_items').html(cartdata);
                     var carttotals = $(t).find('.price-subtotals').html();       
                    $('.price-subtotals').html(carttotals);
                  }
                   $('.slidecartitmmain').html(maincart);
                   $('.slidecart_form').html(maincartprice);
            $("#overlay").addClass("is-active"), $(".inline-cart").addClass("is-active"),$('html').addClass('slidecart-is-open');           
          },
        });
      },
    });
  });




  

  $("body").on("change", ".changequantity", function () {
    var t = $(this).attr("data-line-item-index");
    console.log(t);
    var a = $(this).val();
    console.log(a),
      $.ajax({
      type: "POST",
      url: "/cart/change.js",
      data: "quantity=" + a + "&line=" + t,
      dataType: "json",
      success: function (t) {
        if (t.item_count > 0) {
          $(".cart-count-bubble span").html(t.item_count);
          $('.cart-count-bubble').removeClass('visually-hidden');
        } else {
          $(".cart-count-bubble span").html(t.item_count);
        }
        if(t.item_count == 0){
          $('.cart-count-bubble').addClass('visually-hidden');
        }
        $.ajax({
          type: "GET",
          url: url_p,
          dataType: "html",
          success: function (t) {
                      var minicartdata = $(t).filter('#slidingcartmain').html();
               var maincart = $(minicartdata).find('.slidecartitmmain').html();
                var maincartprice = $(minicartdata).find('.slidecart_form').html();
               var progree_msg = $(t).find(".cust-shptxt").html();
                var progree_width = $(t).find(".cust-prg b").attr("style");
                addRemoveProgress_s(progree_msg,progree_width);
           setTimeout(function(){
                   upsells_slick();
                },200)
                 if (window.location.href.indexOf("/cart") > -1) {
                    var cartdata = $(t).find('.c_cart_items').html();
                    $('.c_cart_items').html(cartdata);
                     var carttotals = $(t).find('.price-subtotals').html();       
                    $('.price-subtotals').html(carttotals);
                  }
                   $('.slidecartitmmain').html(maincart);
                   $('.slidecart_form').html(maincartprice);
          },
        });
      },
    });
  });
function getDeleteData(url){

          $.ajax({
          type: 'GET',
          url: url,
          dataType: 'json',
          success: function(cartdata){
            $('.cart-count-bubble span').html(cartdata.item_count);
            if(cartdata.item_count > 0){
              if($(".cart-count-bubble").length > 0){
                
              }else{
                $(".header__icon--cart").append("<div class='cart-count-bubble'><span aria-hidden='true'>"+ cartdata.item_count +"</span></div>")
              }
              $('.cart-count-bubble').removeClass('visually-hidden');
            }
            if(cartdata.item_count == 0){
              $('.cart-count-bubble').addClass('visually-hidden');
              $(".inline-cart").addClass("cart_empty")
            }
            $.ajax({
              type: "GET",
              url: url,
              dataType: 'html',
              success: function(data) {
                var minicartdata = $(data).filter('#slidingcartmain').html();
               var maincart = $(minicartdata).find('.slidecartitmmain').html();
                var maincartprice = $(minicartdata).find('.slidecart_form').html();
                   var progree_msg = $(data).find(".cust-shptxt").html();
                var progree_width = $(data).find(".cust-prg b").attr("style");
                addRemoveProgress_s(progree_msg,progree_width);
                  if (window.location.href.indexOf("/cart") > -1) {
                    var cartdata = $(data).find('.c_cart_items').html();
                    $('.c_cart_items').html(cartdata);
                     var carttotals = $(data).find('.price-subtotals').html();       
                    $('.price-subtotals').html(carttotals);
                    if($(data).find(".slidecart_items .line-item").length == 0){
                      $(".c_cart_container .empty_cart").css("display","flex");
                      $(".c_cart_container .cart_subtotal_mobile").addClass("hidden")
                      $(".c_cart_container .reserved_text").css("display","none");
                      $(".c_cart_container .c_cart_items").css("display","none");
                      $(".c_cart_container .c_cart_checkout").css("display","none");
                    }
                  }
                  $('#slidingcartmain').html(minicartdata);
                 setTimeout(function(){
                   upsells_slick();
                },200)


              }
            });
          }
        });
}

  
  $("body").on("click", ".remove-item", function () {
      var quantity_x = $(this).closest(".qty-box-with-remove").find(".cart__qty-input").val();
       $(this).find(".removing_svg").css("display","none");
      $(this).find(".rotating_svg").css("display","block");
     var line_x = $(this).attr("data-line-item-index");
     console.log(line_x)
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=0&line='+line_x,
      dataType: 'json',
      success: function(response){
        if($(".slidecart_items .line-item").length ==  $(".slidecart_items .line-item[data_free]").length + 1  ){
            $.ajax({
            type: "POST",
            url: '/cart/clear.js',
            data: '',
            dataType: 'json',
            success: function() { 
              getDeleteData(url_p);
              console.log("cleared");
            },
            error: function(XMLHttpRequest, textStatus) {
              /* error code */
            }
          });
        }else{
            getDeleteData(url_p);
        }
      }
    });
  })

  function extractBaseProductName(fullName) {
  // Remove anything in square brackets and trim whitespace
  return fullName.replace(/\s*\[.*?\]\s*/g, '').trim();
}
  
    $("body").on("change", ".item-qty-selector", function () {
    var a = $(this).find(":selected").val();
      var t =$(this).attr("data-line-item-index");
      var element_x = $(this).closest('.line-item');
      $("#cartCheckout").addClass('active');
    $.ajax({
      type: "POST",
      url: "/cart/change.js",
      data: "quantity=" + a + "&line=" + t,
      dataType: "json",
      success: function (data) { 
        
        if(element_x.find(".p_free_products_form").length){
        const $container = $(".line-item-container");
        const dataTitle = element_x.find(".p_free_products_form").data('title');
        
           if (dataTitle) {
      const baseDataTitle = extractBaseProductName(dataTitle);
      const $matchingLineItem = $container.find('.line-item').filter(function() {
        const itemTitle = $(this).find('.line-item-title a').text().trim();
        const baseItemTitle = extractBaseProductName(itemTitle);
        return baseItemTitle === baseDataTitle;
      });
      
        if ($matchingLineItem.length > 0) {
        const lineIndex = $matchingLineItem.find('.item-qty-selector, .variant-option').first().data('line-item-index');
             $.ajax({
                  type: "POST",
                  url: "/cart/change.js",
                  data: "quantity=" + a + "&line=" + lineIndex ,
                  dataType: "json",
                  success: function (data) { 
                     updateCartUI(data)
                    $("#cartCheckout").removeClass('active');
                  }
                     })
      }
    }  
        }else{
          updateCartUI(data)
          $("#cartCheckout").removeClass('active');
        }

        
       
      /*  if(element_x.find(".p_free_products_form").length){
             $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: element_x.find(".p_free_products_form").find("input,select,textarea").serialize(),
            dataType: 'json',
            success: function(response){
              updateCartUI(t)
            } 
            })
        }else{
        updateCartUI(t)
        }*/
         
      }
    });
  });



$("body").on("change", ".variant-option", function() {
  const $this = $(this);
  const $container = $this.closest(".product-container");
  const variants = $container.data("variants");
  const productOptions = $container.data("options");
  const lineIndex = $container.data("line-item-index");
  const $variantIdInput = $container.find(".selected-variant-id");
  
  // Get all selected options
  const selectedOptions = {};
  $container.find('.variant-option').each(function() {
    const optionName = $(this).data('option');
    selectedOptions[optionName] = $(this).val();
  });
  
  // Find matching variant
  const selectedVariant = variants.find(variant => {
    return variant.options.every((option, index) => {
      const optionName = productOptions[index].toLowerCase().replace(' ', '-');
      return option === selectedOptions[optionName];
    });
  });
  
  if (selectedVariant) {
    $variantIdInput.val(selectedVariant.id);
    updateCartItem(lineIndex, selectedVariant.id);
  }
});


$("body").on("change", ".cart_vars_colors select", function() {
  const $this = $(this);
  const $container = $this.closest(".cart_vars_colors");
  const lineIndex = $container.data("line-item-index");
  const selectedVariantId = $this.val();
  
  // Disable the select during processing
  $this.prop('disabled', true);
  console.log(lineIndex,selectedVariantId )
  if (selectedVariantId) {
    updateCartItem_x(lineIndex, selectedVariantId);
  }
});


  function updateCartItem_x(lineIndex, variantId) {
  let removalTriggered = false;
  let itemAdded = false;
   $("#cartCheckout").addClass('active');
  // First add the new variant to cart
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: {
      id: variantId,
      quantity: 1
    },
    dataType: 'json',
    success: function() {
      
      itemAdded = true;
      attemptItemRemoval();
    },
    error: function() {
      // Re-enable on error
      $(".cart_vars_colors select").prop('disabled', false);
    }
  });

  function attemptItemRemoval() {
    if (!removalTriggered && itemAdded) {
      removalTriggered = true;
      
      $.ajax({
        type: "POST",
        url: "/cart/change.js",
        data: { 
          quantity: 0, 
          line: parseInt(lineIndex) + 1 // Adjust line index if needed
        },
        dataType: 'json',
        success: function(cartData) {
          updateCartUI(cartData);
          $("#cartCheckout").removeClass('active');
        },
        error: function() {
          // Re-enable on error
          $(".cart_vars_colors select").prop('disabled', false);
        }
      });
    }
  }

  // Fallback removal attempts (similar to your variant-option script)
  for (let i = 0; i < 20; i++) {
    setTimeout(attemptItemRemoval, i * 50);
  }
}

  
function updateCartItem(lineIndex, variantId) {
  const $container = $(`.product-container[data-line-item-index="${lineIndex}"]`);
  const $qtyContainer = $container.closest(".qty_and_size");
  const formData = $qtyContainer.find("input,select,textarea").serialize();
  $("#cartCheckout").addClass('active');
  let removalTriggered = false;
  let itemAdded = false;

  // First add the new item to cart
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: formData,
    dataType: 'json',
    success: function() {
     
      itemAdded = true;
      attemptItemRemoval();
    }
  });

  function attemptItemRemoval() {
    if (!removalTriggered && itemAdded) {
      removalTriggered = true;
      
      $.ajax({
        type: "POST",
        url: "/cart/change.js",
        data: { quantity: 0, line: parseInt(lineIndex) + 1 },
        dataType: 'json',
        success: function(cartData) {
          updateCartUI(cartData);
           $("#cartCheckout").removeClass('active');
        }
      });
    }
  }

  // Fallback removal attempts
  for (let i = 0; i < 20; i++) {
    setTimeout(attemptItemRemoval, i * 50);
  }
}

// Your existing updateCartUI function remains the same
function updateCartUI(cartData) {
  // Update cart count
  $('#cart-count, .cart-count-bubble span').html(cartData.item_count);
  $(".cart-count-bubble").removeClass('visually-hidden');
  
  // Fetch updated cart contents
  $.ajax({
    type: "GET",
    url: url_p,
    dataType: "html",
    success: function(response) {
      const $response = $(response);
      const minicartData = $response.filter('#slidingcartmain').html();
      const progressMsg = $response.find(".cust-shptxt").html();
      const progressWidth = $response.find(".cust-prg b").attr("style");
      const cartItems = $(minicartData).find('.slidecartitmmain').html();
      const cartPrice = $(minicartData).find('.slidecart_form').html();
      
      // Update progress indicators
      addRemoveProgress_s(progressMsg, progressWidth);
      
      // Update cart contents
      $('.slidecartitmmain').html(cartItems);
      $('.slidecart_form').html(cartPrice);
      
        if (window.location.href.indexOf("/cart") > -1) {
                    var cartdata = $(minicartData).find('.c_cart_items').html();
                    $('.c_cart_items').html(cartdata);
                     var carttotals = $(minicartData).find('.price-subtotals').html();       
                    $('.price-subtotals').html(carttotals);
                    
                  }
      // Open cart drawer
      $("#overlay").addClass("is-active");
      $(".inline-cart").addClass("is-active");
      $('html').addClass('slidecart-is-open');
      
      // Initialize upsells slider
      setTimeout(upsells_slick, 200);
    }
  });
}



  $(".product-form__submit:not(.numbers_product)").click(function(e){
    e.preventDefault();
    $(this).addClass("active");
    if ($(".custom_upsells").length){
      $(".custom_upsells").addClass("active");
      scrollToSelectedVariant();
      $("body").addClass("slidecart-is-open");
    }else{
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: $( this ).closest("form").serialize(),
      dataType: 'json',
      success: function(response){
        if($(".p_free_products_form form").length){
             $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: $(".p_free_products_form form").serialize(),
            dataType: 'json',
            success: function(response){
               addFreeProductsToCart()
                .finally(() => {
                  cart_get_data(url_p); // Always refresh cart data
                });
            } 
            })
        }else{
        addFreeProductsToCart()
        .finally(() => {
          cart_get_data(url_p); // Always refresh cart data
        });
        }
      },
      error: function(resp) {
        var getres = JSON.stringify(resp);
        alert(resp.responseJSON.description);
      }
    });
  }
  });

// 1. Define the shared logic in a named function
function handleAddToCart(triggerElement) {
  // Find the loader relative to the element that was clicked
  $(triggerElement).closest(".custom_upps_container").find(".c_datc").addClass("loading");

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: $(".product-form__submit").closest("form").serialize(),
    dataType: 'json',
    success: function(response) {
      if ($(".p_free_products_form form").length) {
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: $(".p_free_products_form form").serialize(),
          dataType: 'json',
          success: function(response) {
            addFreeProductsToCart().finally(() => {
              cart_get_data(url_p);
            });
          }
        });
      } else {
        addFreeProductsToCart().finally(() => {
          cart_get_data(url_p);
        });
      }
    },
    error: function(resp) {
      alert(resp.responseJSON.description);
    }
  });
}

// 2. Original click handler
$(".c_datc").click(function(e) {
  handleAddToCart(this);
});

// 3. New click handler for the close button
$(".product_upps_close").click(function(e) {
  handleAddToCart(this);
});
 $(".upps_atc").click(function(e){
  $(this).addClass("loading");

  if($(this).hasClass("active")){
    // First product form
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: $(this).closest(".product_upps_c")
                  .find(".upps_p_item.active")
                  .find("input,textarea,select")
                  .serialize(),
      dataType: 'json',
      success: function(response){
        // After first product succeeds, post the second product form
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: $(".product-form__submit").closest("form").serialize(),
          dataType: 'json',
          success: function(response){
            if($(".p_free_products_form form").length){
              $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: $(".p_free_products_form form").serialize(),
                dataType: 'json',
                success: function(response){
                  addFreeProductsToCart()
                    .finally(() => {
                      cart_get_data(url_p); // Always refresh cart data
                    });
                }
              });
            } else {
              addFreeProductsToCart()
                .finally(() => {
                  cart_get_data(url_p); // Always refresh cart data
                });
            }
          },
          error: function(resp){
            alert(resp.responseJSON.description);
          }
        });
      },
      error: function(resp){
        alert(resp.responseJSON.description);
      }
    });

  } else {
    // Your existing else block unchanged
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: $(".product-form__submit").closest("form").serialize(),
      dataType: 'json',
      success: function(response){
        if($(".p_free_products_form form").length){
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: $(".p_free_products_form form").serialize(),
            dataType: 'json',
            success: function(response){
              addFreeProductsToCart()
                .finally(() => {
                  cart_get_data(url_p); // Always refresh cart data
                });
            }
          });
        } else {
          addFreeProductsToCart()
            .finally(() => {
              cart_get_data(url_p); // Always refresh cart data
            });
        }
      },
      error: function(resp){
        alert(resp.responseJSON.description);
      }
    });
  }
});



    $(".product-form__submit.numbers_product").click(function(e){
    e.preventDefault();
      if($("#your-name").val() != ''){
        console.log("clicked");
       // $( this ).closest("form").find('[name="id"]').attr("value","11");
        $("fieldset .swatch-flocage:last-child label").click();
      }else{
        console.log("not clicked")
      }
    $(this).addClass("active");
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: $( this ).closest("form").serialize(),
      dataType: 'json',
      success: function(response){
          addFreeProductsToCart()
        .finally(() => {
          cart_get_data(url_p); // Always refresh cart data
        });
      },
      error: function(resp) {
        var getres = JSON.stringify(resp);
        alert(resp.responseJSON.description);
      }
    });

  });

$(".card__size-value button").click(function(e){
    e.preventDefault();
    let elements = $(this);
    let selectedVariantId = $(this).attr("id");
    
    // Find the corresponding variant in pro_vars and update the free product form
    let freeProductForm = elements.closest(".card-grid-centered").find(".c_free_products_form");
    let proVarsOptions = freeProductForm.find(".pro_vars div");
    
    // Get the button text and normalize it (trim and remove extra spaces)
    let selectedButtonText = $(this).text().trim().replace(/\s+/g, ' ');
    
    // Find the matching variant in pro_vars based on the selected variant title
    let matchingProVar = proVarsOptions.filter(function() {
        // Normalize the text for comparison
        return $(this).text().trim().replace(/\s+/g, ' ') === selectedButtonText;
    });

    if (matchingProVar.length) {
        // If found matching variant in pro_vars, use its data-id
        freeProductForm.find("[name='id']").val(matchingProVar.attr("data-id"));
    } else {
        // Otherwise fall back to first variant (original behavior)
        freeProductForm.find("[name='id']").val(proVarsOptions.first().attr("data-id"));
    }
    
    // Rest of your AJAX code remains the same
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: $(this).closest(".card__size-value").find("input,select,textarea").serialize(),
        dataType: 'json',
        success: function(response){
            console.log(elements.closest(".card-grid-centered").find("input,select,textarea").serialize())
            if(elements.closest(".card-grid-centered").find(".c_free_products_form").find("input,select,textarea").length){
                $.ajax({
                    type: 'POST',
                    url: '/cart/add.js',
                    data: elements.closest(".card-grid-centered").find(".c_free_products_form").find("input,select,textarea").serialize(),
                    dataType: 'json',
                    success: function(response){
                        addFreeProductsToCart()
                        .finally(() => {
                            cart_get_data(url_p); // Always refresh cart data
                        });
                    } 
                })
            } else {
                addFreeProductsToCart()
                .finally(() => {
                    cart_get_data(url_p); // Always refresh cart data
                });
            }
        },
        error: function(resp) {
            var getres = JSON.stringify(resp);
            alert(resp.responseJSON.description);
        }
    });
});

  
  
  

   $(".custom-sticky").click(function(e){
    e.preventDefault();
     $("#main-product .product-form__cart-submit").click()
   })


});

$(".ups_swatch-element").click(function(){
  $(this).closest(".ups_prod").find(".upsel_form [name='id']").attr("value",$(this).attr('data-id'));
  $(this).closest(".ups_prod").find(".ups_swatch-element").removeClass("active");
  $(this).addClass("active");
})



    $(".upsels_btn").click(function(e){
    e.preventDefault();
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: $(".ups_prod_1 .upsel_form").find("input,select,textarea").serialize(),
      dataType: 'json',
      success: function(response){
         $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: $(".ups_prod_2 .upsel_form").find("input,select,textarea").serialize(),
      dataType: 'json',
      success: function(response){
        $.ajax({
          type: 'GET',
          url: '/cart.js',
          dataType: 'json',
          success: function(cartdata){
            $('#cart-count').html(cartdata.item_count);
                 $('.cart-count-bubble span').html(cartdata.item_count);
            if(cartdata.item_count > 0){
               if($(".cart-count-bubble").length > 0){
                
              }else{
                $(".header__icon--cart").append("<div class='cart-count-bubble'><span aria-hidden='true'>"+ cartdata.item_count +"</span></div>")
              }
              $('#cart-count').removeClass('visually-hidden');
            }
            if(cartdata.item_count == 0){
              $('#cart-count').addClass('visually-hidden');
            }
            $.ajax({
              type: "GET",
              url: url_p,
              dataType: 'html',
              success: function(data){
               var minicartdata = $(data).filter('#slidingcartmain').html();
                  var progree_msg = $(data).find(".cust-shptxt").html();
                var progree_width = $(data).find(".cust-prg b").attr("style");
                $(".inline-cart").removeClass("cart_empty");
                addRemoveProgress_s(progree_msg,progree_width);
               setTimeout(function(){
                   upsells_slick();
                },200)
                 if (window.location.href.indexOf("/cart") > -1) {
                    var cartdata = $(data).find('.c_cart_items').html();
                    $('.c_cart_items').html(cartdata);
                     var carttotals = $(data).find('.price-subtotals').html();       
                    $('.price-subtotals').html(carttotals);
                  }
                  $('#slidingcartmain').html(minicartdata);     
              }
            });
                            $("#overlay").addClass("is-active");
                $("#slidingcartmain").removeClass("slide_empty");
                $(".alm-cart-empty").remove();
                $(".inline-cart").addClass("is-active");
                $('body').addClass('cstm_toggle_cls');
                $('body').addClass('slidecart-is-open');
                $('html').addClass('slidecart-is-open');

          }

        });
        

      }
         })
      },
      error: function(resp) {
        var getres = JSON.stringify(resp);
        alert(resp.responseJSON.description);
      }
    });

  });


let ic = false;
    for (let ix = 0; ix < 2000; ix=ix+50) {
      
setTimeout(function(){
  if(ic == false){
  if($(".wishlist-move-cart").length){
      console.log("added");
    ic = true;
  $(".wishlist-move-cart").click(function(e){
    e.preventDefault();

   let is = false;
    for (let id = 0; id < 2000; id=id+50) { 
    setTimeout(function(){
      if(is == false){
  if($(".wishlist-popup").length){
        is = true;
               $.ajax({
          type: 'GET',
          url: '/cart.js',
          dataType: 'json',
          success: function(cartdata){
            $('#cart-count').html(cartdata.item_count);
                 $('.cart-count-bubble span').html(cartdata.item_count);
            if(cartdata.item_count > 0){
               if($(".cart-count-bubble").length > 0){
                
              }else{
                $(".header__icon--cart").append("<div class='cart-count-bubble'><span aria-hidden='true'>"+ cartdata.item_count +"</span></div>")
              }
              $('#cart-count').removeClass('visually-hidden');
            }
            if(cartdata.item_count == 0){
              $('#cart-count').addClass('visually-hidden');
            }
            $.ajax({
              type: "GET",
              url: url_p,
              dataType: 'html',
              success: function(data){
               var minicartdata = $(data).filter('#slidingcartmain').html();
                  var progree_msg = $(data).find(".cust-shptxt").html();
                var progree_width = $(data).find(".cust-prg b").attr("style");
                $(".inline-cart").removeClass("cart_empty");
                addRemoveProgress_s(progree_msg,progree_width);
               setTimeout(function(){
                   upsells_slick();
                },200)
                if (window.location.href.indexOf("/cart") > -1) {
                    var cartdata = $(data).find('.c_cart_items').html();
                    $('.c_cart_items').html(cartdata);
                     var carttotals = $(data).find('.price-subtotals').html();       
                    $('.price-subtotals').html(carttotals);
                  }
                  $('#slidingcartmain').html(minicartdata);     
              }
            });
                            $("#overlay").addClass("is-active");
                $("#slidingcartmain").removeClass("slide_empty");
                $(".alm-cart-empty").remove();
                $(".inline-cart").addClass("is-active");
                $('body').addClass('cstm_toggle_cls');
                $('body').addClass('slidecart-is-open');
                $('html').addClass('slidecart-is-open');

          }

        });
  }
      }
      
    },id)
    }
   })
  }
  }  
},ix)
    }





if (window.matchMedia('(max-width: 749px)').matches) {
$(".quick-add-btn .button-unstyled").click(function() {
  $(".card-options-wrapper").removeClass("active");
  $(this).closest('.card-options-wrapper').addClass("active");
})
}


let i_quick = false;
    for (let ix_quick = 0; ix_quick < 4000; ix_quick=ix_quick+50) {
setTimeout(function(){
  if(i_quick == false){
if($("product-recommendations .quick-add-btn .button-unstyled").length){
  i_quick = true;
if (window.matchMedia('(max-width: 749px)').matches) {
$("product-recommendations .quick-add-btn .button-unstyled").click(function() {
  $("product-recommendations .card-options-wrapper").removeClass("active");
  $(this).closest('product-recommendations .card-options-wrapper').addClass("active");
})
}
$(".card__size-value button").click(function(e){
    e.preventDefault();
    let elements = $(this);
    let selectedVariantId = $(this).attr("id");
    
    // Find the corresponding variant in pro_vars and update the free product form
    let freeProductForm = elements.closest(".card-grid-centered").find(".c_free_products_form");
    let proVarsOptions = freeProductForm.find(".pro_vars div");
    
    // Get the button text and normalize it (trim and remove extra spaces)
    let selectedButtonText = $(this).text().trim().replace(/\s+/g, ' ');
    
    // Find the matching variant in pro_vars based on the selected variant title
    let matchingProVar = proVarsOptions.filter(function() {
        // Normalize the text for comparison
        return $(this).text().trim().replace(/\s+/g, ' ') === selectedButtonText;
    });

    if (matchingProVar.length) {
        // If found matching variant in pro_vars, use its data-id
        freeProductForm.find("[name='id']").val(matchingProVar.attr("data-id"));
    } else {
        // Otherwise fall back to first variant (original behavior)
        freeProductForm.find("[name='id']").val(proVarsOptions.first().attr("data-id"));
    }
    
    // Rest of your AJAX code remains the same
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: $(this).closest(".card__size-value").find("input,select,textarea").serialize(),
        dataType: 'json',
        success: function(response){
            console.log(elements.closest(".card-grid-centered").find("input,select,textarea").serialize())
            if(elements.closest(".card-grid-centered").find(".c_free_products_form").find("input,select,textarea").length){
                $.ajax({
                    type: 'POST',
                    url: '/cart/add.js',
                    data: elements.closest(".card-grid-centered").find(".c_free_products_form").find("input,select,textarea").serialize(),
                    dataType: 'json',
                    success: function(response){
                        addFreeProductsToCart()
                        .finally(() => {
                            cart_get_data(url_p); // Always refresh cart data
                        });
                    } 
                })
            } else {
                addFreeProductsToCart()
                .finally(() => {
                    cart_get_data(url_p); // Always refresh cart data
                });
            }
        },
        error: function(resp) {
            var getres = JSON.stringify(resp);
            alert(resp.responseJSON.description);
        }
    });
});
}
  }
},ix_quick)
    }



$(".next_arrow").click(function(){
 let iys = $(this);
  setTimeout(function(){
    if(iys.closest("slider-component").find(".slider-button--next").attr("disabled") == "disabled"){
     iys.addClass("inactive");
  }
  },300)
    
  $(this).closest("slider-component").find(".prev_arrow").removeClass("inactive");
  $(this).closest("slider-component").find(".slider-button--next").click();
})
$(".prev_arrow").click(function(){
   let ixs = $(this);
  setTimeout(function(){
    if(ixs.closest("slider-component").find(".slider-button--prev").attr("disabled") == "disabled"){
     ixs.addClass("inactive");
  }
  },300)
  $(this).closest("slider-component").find(".next_arrow").removeClass("inactive");
  $(this).closest("slider-component").find(".slider-button--prev").click();
})
